import PresentationFormControllerNew from "../components/presentations/PresentationFormControllerNew";
import { Alert, Box } from "@mui/material";
import { isRegistrationOpen } from "../utils/utils";
import { PresentationWithId } from "../interfaces/IPresentations";
import { useApplicationContext } from "../contexts/ApplicationContext";
import { useContestContext } from "../contexts/ContestContext";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigationHelper } from "../hooks/useNavigationHelper";
import { usePresentationsContext } from "../contexts/PresentationsContext";

export default function ApplicationPresentationAdd() {
  const { application } = useApplicationContext();
  const { contest } = useContestContext();
  const { handlePresentationAdd } = usePresentationsContext();
  const { goBackToApplicationDetails } = useNavigationHelper();
  const location = useLocation();
  const savedState = location.state;
  
  const [showRegistrationClosedAlert, setShowRegistrationClosedAlert] = useState(false);
  const wasRegistrationOpenRef = useRef<boolean>(true); // Zakładamy, że rejestracja była otwarta na początku

  // Śledź zmiany statusu rejestracji - pokaż alert jeśli została zamknięta podczas pracy
  useEffect(() => {
    if (!contest) return;
    
    const registrationOpen = isRegistrationOpen(contest);
    
    // Jeśli rejestracja była otwarta, a teraz jest zamknięta - pokaż alert
    if (wasRegistrationOpenRef.current && !registrationOpen) {
      setShowRegistrationClosedAlert(true);
    }
    
    // Zaktualizuj referencję
    wasRegistrationOpenRef.current = registrationOpen;
  }, [contest]);

  const handleAddPresentation = async (presentation: PresentationWithId) => {
    // Sprawdź jeszcze raz przed zapisem
    if (!isRegistrationOpen(contest || undefined)) {
      setShowRegistrationClosedAlert(true);
      return;
    }

    const result = await handlePresentationAdd(presentation);
    if (result.success) {
      // Wróć do poprzedniej strony z zachowaniem state
      goBackToApplicationDetails(
        application?.contestId as string,
        application?.id as string,
        savedState,
      );
    } else {
      console.error("Błąd podczas dodawania prezentacji:", result.error);
    }
  };

  const registrationOpen = isRegistrationOpen(contest || undefined);

  return (
    <>
    {/* ALERT - REJESTRACJA ZAMKNIETA */}
      {showRegistrationClosedAlert && (
        <Box sx={{ mb: 2 }}>
          <Alert severity="warning" sx={{ border: "1px solid", borderColor: "warning.main", borderRadius: 1 }}>
            W trakcie dodawania prezentacji rejestracja na {contest?.name || "zawody"} została zakończona. Nie można dodać prezentacji do zgłoszenia.
          </Alert>
        </Box>
      )}

      {/* FORMULARZ - DODAWANIE PREZENTACJI */}
      <PresentationFormControllerNew
        onSubmit={handleAddPresentation}
        onCancel={() =>
          goBackToApplicationDetails(
            application?.contestId as string,
            application?.id as string,
            savedState,
          )
        }
        registrationBlocked={!registrationOpen}
      />
    </>
  );
}
